import { BASE_URL, BASE_APP_URL } from "settings";

export const BASE_APP_PATH = "/";

export const PRIVACY_POLICY = `${BASE_URL}/privacy`;
export const TERM_OF_USE = `${BASE_APP_URL}/term-of-use`;
